import Swiper from "swiper";
export default {
  components: {},
  data() {
    return {
      //   elmentList: [
      //     {
      //       pcElementId: 464,
      //       phoneElementId: 477,
      //       descList: [
      //         {
      //           descName: "线上智选",
      //           sort: 1,
      //         },
      //         {
      //           descName: "线下闪送",
      //           sort: 2,
      //         },
      //         {
      //           descName: "灵活使用",
      //           sort: 3,
      //         },
      //         {
      //           descName: "巡检无忧",
      //           sort: 4,
      //         },
      //       ],
      //       type: "image",
      //       sort: 1,
      //     },
      //     {
      //       pcElementId: 465,
      //       phoneElementId: 478,
      //       descList: [
      //         {
      //           descName:
      //             "七腾机器人提供产品使用服务，客户按期支付使用费用即可享有产品部署、后台设置、技术支持、软件升级、维修保养等服务内容。使用服务周期内，客户享有产品的使用权，七腾机器人保有产品所有权，服务周期根据不同产品类型约定选择。",
      //           sort: 1,
      //         },
      //       ],
      //       type: "image",
      //       sort: 2,
      //     },

      //     {
      //       pcElementId: 466,
      //       phoneElementId: 479,
      //       descList: [
      //         {
      //           descName: "超低日付低至千元 算法维保一站全包",
      //           sort: 1,
      //         },
      //         {
      //           descName: "灵活转购随您畅选 优享数智全新体验",
      //           sort: 2,
      //         },
      //         {
      //           descName: "灵活周期",
      //           sort: 3,
      //         },
      //         {
      //           descName: "多模式可供选择,使用周期灵活调配",
      //           sort: 4,
      //         },
      //       ],
      //       type: "image",
      //       sort: 5,
      //     },
      //     {
      //       pcElementId: 467,
      //       phoneElementId: 480,
      //       descList: [
      //         {
      //           descName: "风险可控",
      //           sort: 1,
      //         },
      //         {
      //           descName: "短期使用进行产品试用具备较高试错空间。",
      //           sort: 2,
      //         },
      //       ],
      //       type: "image",
      //       sort: 6,
      //     },
      //     {
      //       pcElementId: 468,
      //       phoneElementId: 481,
      //       descList: [
      //         {
      //           descName: "超低日付低至千元 算法维保一站全包",
      //           sort: 1,
      //         },
      //         {
      //           descName: "灵活转购随您畅选 优享数智全新体验",
      //           sort: 2,
      //         },
      //         {
      //           descName: "低使用成本",
      //           sort: 2,
      //         },
      //         {
      //           descName: "一站式服务仅按期支付使用费。",
      //           sort: 3,
      //         },
      //       ],
      //       type: "image",
      //       sort: 7,
      //     },
      //     {
      //       pcElementId: 469,
      //       phoneElementId: 482,
      //       descList: [
      //         {
      //           descName: "零维护成本",
      //           sort: 1,
      //         },
      //         {
      //           descName: "包含维修保养、软件升级、技术支持等。",
      //           sort: 2,
      //         },
      //       ],
      //       type: "image",
      //       sort: 8,
      //     },
      //     {
      //       pcElementId: "",
      //       phoneElementId: "",
      //       descList: [
      //         {
      //           descName: "使用服务产品列表",
      //           sort: 1,
      //         },
      //       ],
      //       type: "image",
      //       sort: 9,
      //     },
      //     {
      //       pcElementId: 470,
      //       phoneElementId: 483,
      //       descList: [
      //         {
      //           descName: "防爆四足机器人-X3 8TABLE",
      //           sort: 1,
      //         },
      //       ],
      //       type: "image",
      //       sort: 10,
      //     },
      //     {
      //       pcElementId: 471,
      //       phoneElementId: 484,
      //       descList: [
      //         {
      //           descName: "防爆轮式机器人-S9LS-04",
      //           sort: 1,
      //         },
      //       ],
      //       type: "image",
      //       sort: 11,
      //     },
      //     {
      //       pcElementId: 472,
      //       phoneElementId: 485,
      //       descList: [
      //         {
      //           descName: "防爆轮式机器人-SGLS-C3",
      //           sort: 1,
      //         },
      //       ],
      //       type: "image",
      //       sort: 12,
      //     },
      //     {
      //       pcElementId: 473,
      //       phoneElementId: 486,
      //       descList: [
      //         {
      //           descName: "防爆轮式机器人-L4-S",
      //           sort: 1,
      //         },
      //       ],
      //       type: "image",
      //       sort: 13,
      //     },
      //     {
      //       pcElementId: 474,
      //       phoneElementId: 487,
      //       descList: [
      //         {
      //           descName: "防爆轮式机器人-L7 TWISTER",
      //           sort: 1,
      //         },
      //       ],
      //       type: "image",
      //       sort: 14,
      //     },

      //     {
      //       pcElementId: "",
      //       phoneElementId: "",
      //       descList: [
      //         {
      //           descName: "服务周期自选",
      //           sort: 1,
      //         },
      //       ],
      //       type: "image",
      //       sort: 15,
      //     },

      //     {
      //       pcElementId: 475,
      //       phoneElementId: 488,
      //       descList: [
      //         {
      //           descName: "以月为周期，3-12个月可选",
      //           sort: 1,
      //         },
      //         {
      //           descName: "以年为周期，1-3年可选",
      //           sort: 2,
      //         },
      //         {
      //           descName: "以年为周期，期满后1元转购",
      //           sort: 3,
      //         },
      //         {
      //           descName: "先享后付，低成本抢鲜体验",
      //           sort: 4,
      //         },
      //         {
      //           descName: "“悦享”服务",
      //           sort: 5,
      //         },
      //         {
      //           descName: "“智享”服务",
      //           sort: 6,
      //         },
      //         {
      //           descName: "“尊享”服务",
      //           sort: 7,
      //         },
      //         {
      //           descName: "“优享”服务",
      //           sort: 8,
      //         },
      //         {
      //           descName:
      //             "*该方案七腾机器人有限公司提供，具体方案内容以签订的合同为准。",
      //           sort: 8,
      //         },
      //       ],
      //       type: "image",
      //       sort: 16,
      //     },
      //     {
      //       pcElementId: 476,
      //       phoneElementId: 489,
      //       descList: [
      //         {
      //           descName: "",
      //           sort: 1,
      //         },
      //       ],
      //       type: "image",
      //       sort: 17,
      //     },
      //   ],
      elmentList: [],
    };
  },
  created() {
    // this.$store.dispatch("pageset/getSourceData", {
    //   createBy: "",
    //   updateBy: "",
    //   elmentList: this.elmentList,
    //   pageId: this.$route.query.pageId, //页面id
    //   pageName: this.$route.path,
    //   path: this.$route.path,
    //   remark: "",
    // });
    // 获取当前页面的配置信息
    this.$store
      .dispatch("pageset/getPageInfo", this.$route.query.pageId)
      .then(() => {
        this.elmentList = this.$store.state.pageset.sourceData.elmentList;
        setTimeout(() => {
          this.aboutSwiper();
        }, 100);
      });
  },
  methods: {
    // 初始化轮播图
    aboutSwiper() {
      let that = this;
      this.aboutswiper = new Swiper(".mySwiper", {
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          // type:'custom'
          renderBullet: function (index, className) {
            if (that.$store.state.pageset.pcshow) {
              return (
                '<span class="' +
                className +
                '">' +
                that.elmentList[index + 7].descList[0].descName +
                "</span>"
              );
            } else {
              return `<span class="${className}"> </span>`;
            }
          },
        },
        autoplay: true,
        speed: 2000,
        loop: true,
        effect: "fade", //切换效果
        fadeEffect: {
          crossFade: true, //开启淡出。过渡时，原slide透明度从1->0（淡出），过渡中的slide透明度从0->1（淡入），其他slide透明度0。
          //false  关闭淡出。过渡时，原slide透明度为1（不淡出），过渡中的slide透明度从0->1（淡入），其他slide透明度0。
        },
      });
    },
    retention() {
      // 跳转到新的订购页面
      this.$router.push("/employment/reservation");
    },
  },
};
